import React, { useContext, useEffect, useRef, useState } from "react";
import { animated} from "react-spring";

import { useScreenTransition } from "../../Hooks/useScreenTransition";

import "react-datepicker/dist/react-datepicker.css";
import { DataContext } from "../../Context/DataContext";
import { NotificationContext } from "../../Context/NotificationContext";
import { TransitionContext } from "../../Context/TransitionContext";
import TopBar from "../../Components/TopBar";
import { useParams } from "react-router-dom";
import { AuthContext } from "../../Context/AuthContext";
import AccountNavBar from "../../NewComponents/AccountNavBar";
import SendPaymentLinkPopUp from "../../NewComponents/SendPaymentLinkPopUp";
import PopUpModal from "../../NewComponents/PopUpModal";
import {ReactComponent as ORDERSUCCESS} from "../../assets/icons/order-success.svg";
import { ReactComponent as SORT } from "../../assets/icons/sort.svg";
import { ReactComponent as SORTBLACK } from "../../assets/icons/sort-black.svg";

import { ReactComponent as EXPEDITED } from "../../assets/icons/order-expedited.svg";
import { ReactComponent as EXPEDITEDPLUS } from "../../assets/icons/expedited-plus.svg";
import { ReactComponent as HARDCOPY } from "../../assets/icons/order-hard-copy.svg";
import { ReactComponent as NOTRY } from "../../assets/icons/order-notry.svg";
import { ReactComponent as DOWNLOAD } from "../../assets/icons/Download.svg";
import { ReactComponent as CANCELORDER } from "../../assets/icons/cancel-order.svg";
import NewButton from "../../NewComponents/NewButton";
import "./SingleInvoice.css";
import { languages } from "../../Data/languages";
import { INVOICESTATUS, ORDERSTATUS } from "../../Data/statuses";
import { formatTotal, getDiscount, getShortOrderNo, getTotal } from "../../Data/Functions";
import NoData from "../../NewComponents/NoData";
import { Info } from "react-feather";
import { firestore } from "../../firebase.config";
import OpenInvoiceModal from "../../NewComponents/OpenInvoiceModal";
import GetFileTypeElement from "../../Data/Functions/getFileType";

const SingleInvoiceBackend = ({windowSize}) => {
    const { itemID } = useParams();
  const { transitionTo } = useScreenTransition();
  const { userData } = useContext(DataContext);
  const { showNotification } = useContext(NotificationContext);
  const { signedIn } = useContext(AuthContext);
  const { setColor } = useContext(TransitionContext);

  const [showDetailModal, setShowDetailModal] = useState("");

  const [showStatusHoverBox, setShowStatusHoverBox] = useState(false);


    const [loading, setLoading] = useState(false);
     let nextPointer = useRef();
      if (!nextPointer.current) nextPointer.current = null;

    const [invoice, setInvoice] = useState();

    const [selectedOrderSort, setSelectedOrderSort] = useState("timestamp");
    const [selectedSendPayment, setSelectedSendPayment] = useState("");
    const [approvePaymentModal, setApprovePaymentModal] = useState(false);
    const [approvePaymentBtn, setApprovePaymentBtn] = useState("Approve Payment");
    const [openInvoiceModal, setOpenInvoiceModal] = useState();

  useEffect(() => {
    setColor(true);
  }, [setColor]);

  useEffect(() => {
      if(!signedIn || (userData && userData.role === "client")){
        return transitionTo("/");
      }
    }, [signedIn, userData]);

   const getOrderData = async(orderId) => {
     const data = await firestore.collection("orders").doc(orderId).get().then(
        itemDoc => {
          if(itemDoc.exists){
            console.log(itemDoc.data())
            return {...itemDoc.data(), id: itemDoc.id};
          }else{
            return {id: orderId}
          }
        }).catch((e) => {
        // console.log(error);
        setLoading(false);
        showNotification(
          "Error",
          "An error ocurred while loading the orders. Please, try again. If it persists, contact Support.",
          "error"
        );
      })
      return data
    }

  useEffect(
    (e) => {
      let unsub = null;
      if (itemID) {
        setLoading(true);
        try{
          unsub = firestore.collection("orderInvoices").doc(itemID).onSnapshot(
            async itemDoc => {
              if(itemDoc.exists){
                const orders = await Promise.all( itemDoc.data().orders.map(o =>  getOrderData(o.id)));
                const invoiceData = {...itemDoc.data(), id: itemDoc.id, orders: orders};

                setInvoice(invoiceData);;
                setLoading(false);
              }else{
                transitionTo("/", e);
              }
            });

          }catch(error){
            // console.log(error);
            setLoading(false);
            showNotification(
              "Error",
              "An error ocurred while loading the orders. Please, try again. If it persists, contact Support.",
              "error"
            );
          };
        }else{
          transitionTo("/", e);
        }
        return () => unsub && unsub();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [itemID, userData, signedIn]
  );


  const formatDate = (timestamp, showTime = false) => {
    const date = new Date(timestamp);

    const splitted = date.toDateString().split(" ");

    const time = showTime ? (' @ ' + date.toTimeString().substr(0, 5)) : "";

    return (
      splitted[1] +
      " " +
      splitted[2] +
      ", " +
      splitted[3] + time
    );
  };

  const getLanguage = (language) => {
    if (languages.find((lang) => lang.value === language)) {
      return languages.find((lang) => lang.value === language).label;
    } else {
      return "";
    }
  };

  const handlePayment = (invoice) => {
    transitionTo(`/make-payment/invoice/${invoice.id}`);
    
  }
  const handleDownloadInvoice = (invoice) => {
    setOpenInvoiceModal(invoice);
  }

  const downloadFile = url => {
  window.open(url, '_blank')
  }
  const handleDownloadFile = async (file) => {
    try {
      if (!file || !file.url) {
        showNotification("Error", "No file available for download.", "error");
        return;
      }
     downloadFile(file.url);
    } catch (error) {
      console.error("Download Error:", error);
      showNotification("Error", "Failed to download file.", "error");
    }
  };

  const handleApprovePayment = async() => {
    setApprovePaymentBtn("Approving...");
    try{
      await firestore.collection("orderInvoices").doc(invoice.id).update({status: "paid"})
    }catch(e){
      console.log(e)
    }finally{
      setApprovePaymentBtn("Approve Payment");
      setApprovePaymentModal(false);
    }

  }
  const [markasPaidBtn, setMarkasPaidBtn] = useState("Mark as Paid");
    const [showMaunallyPayModal, setShowMaunallyPayModal] = useState(false);
  

  const handleMarkAsPaid = () => {
      setMarkasPaidBtn("Paying...");
      try{
          firestore.collection("orderInvoices").doc(invoice.id).update({
            paymentId: "paid-manually",
            status: "paid",
          }).then(() => {
            const orders = invoice.orders || [];
            orders.forEach(o => {
              firestore.collection("orders").doc(o.id).update({paypalOrderID: "paid"})
            })
          })
      }catch(e){
        showNotification("Error", "Error updating the order.", "error")
      }finally{
        setShowMaunallyPayModal(false);
        setMarkasPaidBtn("Mark as Paid");
      }
      
    }

  return (
    <>
    {openInvoiceModal && <OpenInvoiceModal type="invoice" order={openInvoiceModal} onClose={() => setOpenInvoiceModal(null)}/>}

      {showMaunallyPayModal && (
              <PopUpModal
                title={"Mark Order as Paid"}
                backBtnText="Back to Invoice"
                subText="Are you sure you want to mark this invoice as Paid?"
                text={""}
                btnText={markasPaidBtn}
                iconBgColor="#FFF6EA"
                showClose
                onClose={() => setShowMaunallyPayModal(false)}
                onClick={handleMarkAsPaid}
                onBackClick={() => {
                  setShowMaunallyPayModal(false);
                }}
                disableBtn={markasPaidBtn === "Paying..."}
                warningText={"All the orders related to this invoice will be paid too."}
              >
                <CANCELORDER />
              </PopUpModal>
            )}

      {selectedSendPayment && (
        <SendPaymentLinkPopUp
          data={selectedSendPayment}
          type={"invoice"}
          id={selectedSendPayment.id}
          onClose={() => setSelectedSendPayment("")}
        />
      )}

      {approvePaymentModal && (
        <PopUpModal
          title={"Approve Payment"}
          backBtnText="Back to Invoice"
          subText="Are you sure you want to approve this payment?"
          btnText={approvePaymentBtn}
          iconBgColor="#FFF6EA"
          showClose
          onClose={() => setApprovePaymentModal(false)}
          onClick={() => handleApprovePayment()}
          onBackClick={() => {
            setApprovePaymentModal(false);
          }}
          disableBtn={approvePaymentBtn === "Approving..."}
        >
          <ORDERSUCCESS />
        </PopUpModal>
      )}

      <TopBar />
      <AccountNavBar
        windowSize={windowSize}
        selectedTab={"invoices"}
        breadLinkType="invoice"
        breadLink={`Invoice #${invoice ? (invoice.invoiceNumber) : ""}`}
        accountMainPadding={false}
        bgTransparent={true}
        admin={true}
      >

      {loading && invoice && <NoData loadingText="invoice" type="order" loading={true} showBtn={false} />}
      {!loading && !invoice && <NoData loadingText="order" type="order" loading={false} showBtn={false} />}
        {!loading && invoice && <div className="grid grid-cols-1 gap-4 mt-4 w-full md:w-[calc(100vw-270px)]">
          <div className="orderSummaryInfo lg:flex-row flex-col gap-4">
            <div className="xl:w-[70%] lg:w-2/3  w-full flex flex-row items-center justify-between ">
              <h2 className="createOrderNavbarMenuTitle">
                Invoice #{invoice.invoiceNumber}
              </h2>

              <div
                className="mainOrderStatusWrap"
              >
                {showStatusHoverBox && (
                  <div className="mainOrderStatusHover">
                    <p className="title">Status: {INVOICESTATUS[invoice.status][0]}</p>
                    <p className="subTitle">{INVOICESTATUS[invoice.status][2]}.</p>
                  </div>
                )}
                <div
                  className="mainOrderOrderStatus"
                  style={{
                    backgroundColor: INVOICESTATUS[invoice.status] ? INVOICESTATUS[invoice.status][1] : "",
                  }}
                  onMouseOver={() => setShowStatusHoverBox(true)}
                  onMouseOut={() => setShowStatusHoverBox(false)}
                >

                {INVOICESTATUS[invoice.status] ? INVOICESTATUS[invoice.status][0] : invoice.status}<Info className="statusIcon"/>
                </div>
              </div>
            </div>
            <div
              onClick={() => handleDownloadInvoice(invoice)}
              className="flex flex-row items-center gap-2 bg-white border border-[#E6E7E9] rounded-md font-medium text-[#030F23] px-4 py-2 cursor-pointer"
            >
              View Invoice
            </div>
          </div>

          {!loading && invoice && <div className="mainOrderPageContainer">
            <div className="mainOrderPageContainerOptions">
              <div id="mainPrimary" className="mainOrderPrimaryContent">
                <div className="quotePrimaryOptionsWrapper">
                  <h4 className="quotePrimaryTitle mb-1">Invoice Info</h4>
                  <div className="accInvoiceInfoWrap">
                    {invoice.type === "multipleInvoice" && invoice.billingPeriod && 
                    <>
                      <div className="accSingleInvoiceTitleWrap">
                        <p className="accSingleInvoiceText w-1/5 accSingleInvoiceSubText">
                          Billing Period
                        </p>
                        <p className="accSingleInvoiceText flex-1">
                          {invoice.billingPeriod ? invoice.billingPeriod : "-"}
                        </p>
                      </div>
                      <hr className="w-full my-2" />
                    </>}
                    {invoice.type !== "multipleInvoice" && 
                    <>
                      <div className="accSingleInvoiceTitleWrap">
                        <p className="accSingleInvoiceText w-1/5 accSingleInvoiceSubText">
                          Date
                        </p>
                        <p className="accSingleInvoiceText flex-1">
                          {formatDate(invoice.timestamp)}
                        </p>
                      </div>
                     <hr className="w-full my-2" />
                    </>}
                    {invoice.teamId && (
                      <>
                        <div className="accSingleInvoiceTitleWrap mt-2">
                          <p className="accSingleInvoiceText w-1/5 accSingleInvoiceSubText">
                            Orders
                          </p>
                          <p className="accSingleInvoiceText flex-1">{invoice.orders ? invoice.orders.length : "-"} </p>
                        </div>
                        <hr className="w-full my-2" />
                      </>
                    )}
                    
                    {invoice.type === "multipleInvoice" && 
                    <>
                      <div className="accSingleInvoiceTitleWrap">
                        <p className="accSingleInvoiceText w-1/5 accSingleInvoiceSubText">
                          Date
                        </p>
                        <p className="accSingleInvoiceText flex-1">
                          {formatDate(invoice.timestamp)}
                        </p>
                      </div>
                     <hr className="w-full my-2" />
                    </>}

                     <>
                        <div className="accSingleInvoiceTitleWrap mt-2">
                          <p className="accSingleInvoiceText w-1/5 accSingleInvoiceSubText">
                            Client/Team Name
                          </p>
                          <p className="accSingleInvoiceText flex-1">{invoice.teamId ? invoice.teamName ?? invoice.name : invoice.name} </p>
                        </div>
                        <hr className="w-full my-2" />
                      </>
                  </div>
                </div>

                {invoice.files && <div className="quotePrimaryOptionsWrapper">
                  <div className="w-full flex justify-between items-center">
                    <div className="memberOrderStatus">
                      <h4 className="quotePrimaryTitle">Bank/Check Payment Files</h4>
                    </div>

                  </div>
                   <div className="accSingleQuoteFileWrap mt-2">
                      {invoice.files
                        .map((file, index) => (
                          <>
                            <div
                              key={index}
                              className="fileUploaderLineOuter"
                            >
                              <div className="fileUploaderLine">
                                <div className="fileUploaderLineInfo flex-1">
                                  <GetFileTypeElement file={file}/>
                                  <p
                                    className="fileUploaderLineName w-max"
                                  >
                                    {file.name}
                                  </p>
                                </div>
                                {file.status !== "uploading" &&
                                  file.timestamp && (
                                    <p className="fileUploaderLineSize max-sm:hidden">
                                      {formatDate(file.timestamp)}
                                    </p>
                                  )}
                                {file.status === "uploading" ? (
                                  <div className="fileUploaderLineProgressContainer">
                                    <animated.div
                                      style={{
                                        width: `${file.progress}%`,
                                      }}
                                      className="fileUploaderLineProgress"
                                    />
                                  </div>
                                ) : null}
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'row', gap: '5px' }}>
                                  <DOWNLOAD
                                    className="hardCopyAddressIcon"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => handleDownloadFile(file)}
                                  />
                                  {/* <button
                                    className="commentBtn"
                                    onClick={() => {
                                      // deleteFileFromOrderHandler(file);
                                    }}
                                  >
                                    <TRASH />
                                  </button> */}
                                </div>
                              </div>
                            </div>
                            {invoice.files.length - 1 !== index && (
                              <div className="accSingleQuoteFileDivider"></div>
                            )}
                          </>
                        ))}
                  </div>

                </div>}

                <div className="quotePrimaryOptionsWrapper">
                  <h4 className="quotePrimaryTitle">Orders</h4>
                  <div className="accountDetailsScroll min-h-full h-full">
                    <table className="accountDetailsTable">
                      <thead>
                        <tr>
                          <th>
                            <p className="accountDetailsHeading">ID</p>
                          </th>
                          <th>
                            <div className="accountData">
                              <p className="accountDetailsHeading">Date</p>
                              { selectedOrderSort === "timestamp" ? 
                              <SORT className="sortIcon" onClick={() => setSelectedOrderSort("timestamp")}/> 
                              : <SORTBLACK className="sortIcon" onClick={() => setSelectedOrderSort("timestamp")}/>
                              }
                            </div>
                          </th>
                          <th>
                            <div className="accountData">
                              <p className="accountDetailsHeading">Name</p>
                            </div>
                          </th>
                          {invoice.teamId && <th>
                            <div className="accountData">
                              <p className="accountDetailsHeading">Client</p>
                            </div>
                          </th>}
                          <th>
                            <div className="accountData">
                              <p className="accountDetailsHeading">Language</p>
                            </div>
                          </th>
                          <th>
                            <div className="accountData">
                              <p className="accountDetailsHeading">Services</p>
                            </div>
                          </th>
                          <th>
                            <div className="accountData">
                              <p className="accountDetailsHeading">Status</p>
                              { selectedOrderSort === "status" ? 
                                <SORT className="sortIcon" onClick={() => setSelectedOrderSort("status")}/> 
                                : <SORTBLACK className="sortIcon" onClick={() => setSelectedOrderSort("status")}/>
                                }
                            </div>
                          </th>
                          <th>
                            <div className="accountData">
                              <p className="accountDetailsHeading">Total</p>

                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {invoice.orders.length > 0 && invoice.orders.map((order, i) => (
                          <tr key={order.id + i}>
                            <td>
                              {order.orderNumber && order.orderNumber.toString().length > 12 &&
                                showDetailModal === order.orderNumber && (
                                  <div className="accountdetailHoverBox">
                                    <p
                                      className="quotewidth "
                                    >
                                      {order.orderNumber}
                                    </p>
                                  </div>
                                )}
                              <p className="quotewidth accountDetailsLink" 
                                onMouseOver={() =>
                                  setShowDetailModal(
                                    order.orderNumber
                                  )
                                }
                                onMouseLeave={() => setShowDetailModal("")}
                                onClick={(e) =>
                                  transitionTo(`/office/translations/${order.id}`, e)
                                }>
                                {getShortOrderNo(order.orderNumber, "order")}
                              </p>
                            </td>
                            <td
                              onClick={(e) =>
                                transitionTo(`/office/translations/${order.id}`, e)
                              }
                            >
                              <p className="accountDetailsText">
                                {formatDate(order.timestamp)}
                              </p>
                            </td>
                            <td
                              onClick={(e) =>
                                transitionTo(`/office/translations/${order.id}`, e)
                              }
                            >
                              <p className="accountDetailsText">{order.name}</p>
                            </td>
                            {invoice.teamId && <td
                              onClick={(e) =>
                                transitionTo(`/office/translations/${order.id}`, e)
                              }
                            >
                              <p className="accountDetailsText">{order.clientFirstName ? order.clientFirstName + " " + order.clientLastName : "-"}</p>
                            </td>}
                            <td
                              onClick={(e) =>
                                transitionTo(`/office/translations/${order.id}`, e)
                              }
                            >
                              {showDetailModal ===
                                order.id + order.languageFrom && (
                                  <div className="accountdetailHoverBox">
                                    <p
                                      className="accountDetailsText captialLetters"
                                    >
                                      {getLanguage(order.languageFrom) +
                                        " / " +
                                        getLanguage(order.languageTo)}
                                    </p>
                                  </div>
                                )}
                              <p
                                className="accountDetailsText"
                                style={{
                                  textTransform: "uppercase",
                                  cursor: "pointer",
                                }}
                                onMouseOver={() =>
                                  setShowDetailModal(
                                    order.id + order.languageFrom
                                  )
                                }
                                onMouseLeave={() => setShowDetailModal("")}
                              >
                                {getLanguage(order.languageFrom).substr(0, 2) +
                                  "/" +
                                  getLanguage(order.languageTo).substr(0, 2)}
                              </p>
                            </td>
                            <td
                              onClick={(e) =>
                                transitionTo(`/office/translations/${order.id}`, e)
                              }
                            >
                              {showDetailModal === order.id + "N" && (
                                <div className="accountdetailHoverBox">
                                  <p
                                    className="accountDetailsText captialLetters"
                                  >
                                    Notarization
                                  </p>
                                </div>
                              )}
                              {showDetailModal === order.id + "E" && (
                                <div className="accountdetailHoverBox">
                                  <p
                                    className="accountDetailsText captialLetters"
                                  >
                                    {order.expeditedPlus
                                      ? "Expedited+ Turnaround"
                                      : "Expedited Turnaround"}
                                  </p>
                                </div>
                              )}
                              {showDetailModal === order.id + "H" && (
                                <div className="accountdetailHoverBox">
                                  <p
                                    className="accountDetailsText captialLetters"
                                  >
                                    Mail Hard Copy
                                  </p>
                                </div>
                              )}
                              <p className="accountDetailsText captialLetters flex flex-row gap-2">
                                {order.notarization && (
                                  <NOTRY
                                    style={{ cursor: "pointer" }}
                                    onMouseOver={() =>
                                      setShowDetailModal(order.id + "N")
                                    }
                                    onMouseLeave={() => setShowDetailModal("")}
                                  />
                                )}
                                {order.expedited && (
                                  <EXPEDITED
                                    style={{ cursor: "pointer" }}
                                    onMouseOver={() =>
                                      setShowDetailModal(order.id + "E")
                                    }
                                    onMouseLeave={() => setShowDetailModal("")}
                                  />
                                )}
                                {order.expeditedPlus && (
                                  <EXPEDITEDPLUS
                                    style={{ cursor: "pointer" }}
                                    onMouseOver={() =>
                                      setShowDetailModal(order.id + "E")
                                    }
                                    onMouseLeave={() => setShowDetailModal("")}
                                  />
                                )}
                                {order.hardCopy ? (
                                  <HARDCOPY
                                    style={{ cursor: "pointer" }}
                                    onMouseOver={() =>
                                      setShowDetailModal(order.id + "H")
                                    }
                                    onMouseLeave={() => setShowDetailModal("")}
                                  />
                                ) : (
                                  ""
                                )}
                              </p>
                            </td>
                            <td
                              onClick={(e) =>
                                transitionTo(`/office/translations/${order.id}`, e)
                              }
                            >
                              <p
                                className="accountDetailsText accountDetailsStatus"
                                style={{
                                  backgroundColor: order.cancellationHold && order.status === "on-hold" ? ORDERSTATUS["cancel-hold"][1] : ORDERSTATUS[order.status]
                                    ? ORDERSTATUS[order.status][1]
                                    : "",
                                }}
                              >
                                {order.cancellationHold && order.status === "on-hold" ? ORDERSTATUS["cancel-hold"][0] : ORDERSTATUS[order.status]
                                  ? ORDERSTATUS[order.status][0]
                                  : order.status}
                              </p>
                            </td>
                            <td
                              onClick={(e) =>
                                transitionTo(`/office/translations/${order.id}`, e)
                              }
                            >
                              <p className="accountDetailsText">
                                {order.pagesCount === undefined ||
                                  order.wordCount === undefined
                                  ? "-"
                                  : formatTotal(
                                    getTotal(order) - getDiscount(order)
                                  )}
                              </p>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div className="mainOrderSecondaryContent">
              <div className="mainOrderSecondaryContentWrap">

              {invoice.status === "on-hold" && (
                <div className="orderSummary">
                  <h2 className="orderSummaryInfoType">Approve Payment</h2>
                    <div className="w-full mt-2">
                      <NewButton
                        width="100%"
                        text={"Approve Payment"}
                        onClick={() => setApprovePaymentModal(invoice)}
                        disable={false}
                        icon={false}
                      />
                    </div>
                </div>
              )}

              {(invoice.status === "pay-later" || invoice.status === "overdue") &&
                <div className="orderSummary flex flex-col gap-2">
                  <NewButton text="Mark as Paid" icon={false} width="100%" onClick={() => setShowMaunallyPayModal(true)}/>
                  
                  {/* <NewButton text="Mark as unPaid" disabled={true} icon={false} width="100%" onClick={handleMarkAsUnPaid}/> */}
                </div>
                }

                <div className="orderSummary">
                  <h2 className="orderSummaryTitle">SUMMARY</h2>
                   
                  <div className="orderSummaryInfoWrapper">
                    <div className="orderSummaryInfo">
                      <h4 className="orderSummaryInfoType">Orders</h4>
                    </div>
                    <div className="invoiceOrdersScroll" >
                    { invoice.orders.length > 0 ? 
                    invoice.orders.filter(o => invoice.orders.length > 1 ? o.status !== "cancelled" && o.status !== "refunded" : true).map(order => (
                    <div className="orderSummaryInfo">
                      <p className="orderSummaryInfoCount">
                        {getShortOrderNo(order.orderNumber)}
                      </p>
                      <p className="orderSummaryInfoCount">
                        {formatTotal(getTotal(order) - getDiscount(order))}
                      </p>
                    </div>)) : <p className="orderSummaryInfoCount">"No Orders"</p>}
                    
                    </div>
                  </div>

                    <div className="orderSummaryTotal">
                      <h4>Total</h4>
                      <h4>
                        {formatTotal(invoice.totalPrice)}
                      </h4>
                    </div>
                  {invoice.teamId && invoice.status === "pay-later" && invoice.type !== "multipleInvoice" && (
                    <div className="w-full mt-4">
                      <NewButton
                        width="100%"
                        text={"Send Payment Link"}
                        onClick={() => setSelectedSendPayment(invoice)}
                        disable={false}
                        back={true}
                        icon={false}
                        whiteBtn
                        sendIcon
                      />
                    </div>
                  )}
                 
                </div>
              </div>
            </div>
          </div>}
        </div>}
      </AccountNavBar>
    </>
  )
}

export default SingleInvoiceBackend